import { Controller } from 'stimulus';

export default class extends Controller {

}

$(document).on('turbolinks:load', () => {
  const subscriptionProductLinks = $('.js-select-subscription-product');
  const closeSubscriptionPlan = $('.js-close-subscription-plan');
  const selectSubscriptionPlan = $('.js-select-subscription-plan');

  subscriptionProductLinks.click((event) => {
    event.preventDefault();

    const target = $(event.target);

    const subscriptionSelectorCard = target.parents('.subscription-selector-card');
    const selectorsToHide = subscriptionSelectorCard.siblings('.subscription-selector-card');

    const subscriptionProduct = target.parents('.subscription-product');
    const subscriptionPlan = $(target.attr('href'));

    selectorsToHide.toggleClass('display-none');
    subscriptionPlan.toggleClass('display-none');
    subscriptionProduct.toggleClass('display-none');
    subscriptionSelectorCard.toggleClass('subscription-selector-card--plan-selection');
  });

  closeSubscriptionPlan.click((event) => {
    event.preventDefault();

    const target = $(event.target);

    const subscriptionSelectorCard = target.parents('.subscription-selector-card');
    const selectorsToShow = subscriptionSelectorCard.siblings('.subscription-selector-card');
    const subscriptionProduct = subscriptionSelectorCard.children('.subscription-product');
    const subscriptionPlan = $(target.attr('href'));

    selectorsToShow.toggleClass('display-none');
    subscriptionPlan.toggleClass('display-none');
    subscriptionProduct.toggleClass('display-none');
    subscriptionSelectorCard.toggleClass('subscription-selector-card--plan-selection');
  });

  selectSubscriptionPlan.click((event) => {
    event.preventDefault();

    const target = $(event.target);

    const form = document.querySelector(`${target.attr('href')} form`);
    form.submit();
  });

  $('.session-selection__picker .dropdown-content li').click((event) => {
    const delegateTarget = $(event.delegateTarget);
    const parentContent = delegateTarget.parents('.subscription-selector-card__content');

    const plans = parentContent.find('.js-relevant-subscription-plans').data('plans');
    const planMonthlyCost = parentContent.find('.js-plan-monthly-cost');
    const planDisplayName = parentContent.find('.js-plan-display-name');
    const planServices = parentContent.find('.js-plan-services');

    const selectedPlanName = event.delegateTarget.textContent;
    const selectedPlan = plans.find(p => p.display_name === selectedPlanName);
    const services = [];

    selectedPlan.friendly_services.forEach(([description, unit]) => {
      services.push(`<li class="subscription-line-items__item">
        <span class="line-item__description js-plan-description-zero">${description}</span>
        <span class="line-item__price">
          <div class="prefix"></div>
          <div class="value js-plan-unit-zero">${unit}</div>
        </span>
      </li>`);
    });

    planServices.html(services.join(''));

    planMonthlyCost.text(selectedPlan.monthly_cost_text);
    planDisplayName.text(selectedPlan.display_name);
  });
});
